import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';
import { DateRange } from '@shared/components/DateRangeFilter';

export interface AudienceAnalyticsDto {
  registrations: Array<{ date: string; newUsers: number; totalUsers: number }>;
  activeUsers: Array<{ date: string; count: number }>;
  // T-144 — snapshot dell'ultima piattaforma vista dei tifosi attivi. `unknown`
  // = chi non ha ancora comunicato l'OS; sempre presente, mai redistribuito.
  platformBreakdown: { ios: number; android: number; unknown: number };
}

export function useAnalyticsAudience(range: DateRange) {
  const [from, to] = range;
  return useQuery({
    queryKey: ['analytics', 'audience', from.toISOString(), to.toISOString()],
    queryFn: async () => {
      const res = await apiClient.get<AudienceAnalyticsDto>('/analytics/audience', {
        params: { from: from.toISOString(), to: to.toISOString() },
      });
      return res.data;
    },
  });
}
